// import React, { useState, useEffect } from "react";
// import {
//   Layout,
//   Menu,
//   Card,
//   Table,
//   Button,
//   Modal,
//   Form,
//   Input,
//   InputNumber,
//   Select,
//   Space,
//   Popconfirm,
//   message,
//   Row,
//   Col,
//   Statistic,
//   Tag,
//   Tabs,
//   DatePicker,
//   Upload,
//   Switch,
//   Divider,
//   Badge,
//   Typography,
//   Drawer,
// } from "antd";
// import {
//   ShoppingCartOutlined,
//   AppstoreOutlined,
//   TagsOutlined,
//   GiftOutlined,
//   DashboardOutlined,
//   PlusOutlined,
//   EditOutlined,
//   DeleteOutlined,
//   EyeOutlined,
//   UploadOutlined,
//   DollarOutlined,
//   ShoppingOutlined,
//   UserOutlined,
//   BarChartOutlined,
// } from "@ant-design/icons";
// import { categoryService, productService } from "../services";
// import { useApiEnhanced } from "../hooks/useApiEnhanced";
// import { toast } from "react-toastify";

// const { Header, Sider, Content } = Layout;
// const { Option } = Select;
// const { TextArea } = Input;
// const { Title, Text } = Typography;
// const { TabPane } = Tabs;

// const CategoriesSection = () => {
//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [total, setTotal] = useState(0);

//   const {
//     data: list,
//     loading,
//     error,
//     execute: refetchProducts,
//   } = useApiEnhanced(
//     () => categoryService.getCategories({ page: currentPage, limit: pageSize }),
//     true // Load immediately
//   );

//   const { loading: creating, execute: createCategory } = useApiEnhanced(
//     (productData) => categoryService.createCategory(productData),
//     { immediate: false }
//   );

//   const { loading: editing, execute: editCategory } = useApiEnhanced(
//     (id, productData) => categoryService.updateCategory(id, productData),
//     { immediate: false }
//   );

//   const { loading: deleting, execute: deleteCategory } = useApiEnhanced(
//     (id) => categoryService.deleteCategory(id),
//     { immediate: false }
//   );

//   const [imageUrl, setImageUrl] = useState("");
//   const [imageGalleryVisible, setImageGalleryVisible] = useState(false);
//   const [selectedImageSource, setSelectedImageSource] = useState("upload");
//   const [imageFile, setImageFile] = useState(null);
//   const [categories, setCategories] = useState([]);
//   const [modalVisible, setModalVisible] = useState(false);
//   const [editingCategory, setEditingCategory] = useState(null);
//   const [form] = Form.useForm();

//   // Update categories when data loads
//   useEffect(() => {
//     if (!loading && list?.data) {
//       setCategories(list.data);
//       setTotal(list.total || list.pagination?.total || 0);
//     }
//   }, [loading, list]);

//   // Refetch when pagination changes
//   useEffect(() => {
//     refetchProducts();
//   }, [currentPage, pageSize]);

//   const columns = [
//     {
//       title: "Image",
//       dataIndex: "image",
//       key: "image",
//       render: (image) => (
//         <img
//           src={image?.url || "https://via.placeholder.com/50"}
//           alt="Product"
//           style={{ width: 50, height: 50, objectFit: "cover" }}
//         />
//       ),
//     },
//     { title: "Name", dataIndex: "name", key: "name" },
//     { title: "Description", dataIndex: "description", key: "description" },
//     { title: "Product Count", dataIndex: "productCount", key: "productCount" },
//     {
//       title: "Actions",
//       key: "actions",
//       render: (_, record) => (
//         <Space>
//           <Button
//             icon={<EditOutlined />}
//             onClick={() => handleEdit(record)}
//             size="small"
//           >
//             Edit
//           </Button>
//           <Popconfirm
//             title="Are you sure you want to delete this category?"
//             onConfirm={() => handleDelete(record._id)}
//           >
//             <Button icon={<DeleteOutlined />} danger size="small">
//               Delete
//             </Button>
//           </Popconfirm>
//         </Space>
//       ),
//     },
//   ];

//   const handleEdit = (category) => {
//     setEditingCategory(category);
//     setImageUrl(category.image?.url || "");
//     setImageFile(null);

//     form.setFieldsValue({
//       name: category.name,
//       description: category.description,
//     });
//     setModalVisible(true);
//   };

//   const handleDelete = async (id) => {
//     try {
//       let res = await deleteCategory(id);
//       console.log(res, "res success delete");
//       if (!res?.success) return toast.error(res?.message);

//       // Refresh data after delete
//       await refetchProducts();
//       toast.success("Category deleted successfully");
//     } catch (error) {
//       console.log(error, "error throw");
//       return toast.error(
//         error?.response?.data?.message || "something went wrong!"
//       );
//     }
//   };

//   const handleImageUpload = (info) => {
//     const file = info.file.originFileObj || info.file;
//     setImageFile(file);

//     const reader = new FileReader();
//     reader.onload = (e) => {
//       setImageUrl(e.target.result);
//     };
//     reader.readAsDataURL(file);
//   };

//   const customUpload = ({ file, onSuccess }) => {
//     setTimeout(() => {
//       onSuccess("ok");
//     }, 0);
//   };

//   const handleSubmit = async (values) => {
//     console.log("Form submission values:", values);
//     console.log("Current imageFile:", imageFile);
//     console.log("Current imageUrl:", imageUrl);

//     const formData = new FormData();
//     formData.append("name", values.name);
//     formData.append("description", values.description || "");

//     if (editingCategory) {
//       if (imageFile) {
//         formData.append("image", imageFile);
//         console.log("New image file added for edit:", imageFile.name);
//       } else {
//         console.log("No new image selected, keeping existing image");
//       }
//     } else {
//       if (imageFile) {
//         formData.append("image", imageFile);
//         console.log("Image file added for create:", imageFile.name);
//       }
//     }

//     console.log("FormData contents:");
//     for (let pair of formData.entries()) {
//       console.log(pair[0] + ": ", pair[1]);
//     }

//     try {
//       if (editingCategory) {
//         let res = await editCategory(editingCategory._id, formData);
//         console.log(res, "edit response");
//         if (!res?.success)
//           return toast.error(res?.message || "Category not able to edit");
//         toast.success("Category updated successfully");
//       } else {
//         let result = await createCategory(formData);
//         console.log(result, "result category");
//         if (!result?.success)
//           return toast.error(result?.message || "Failed to create category");
//         toast.success("Category added successfully");
//       }

//       // Refresh data from server
//       await refetchProducts();
//       handleModalClose();
//     } catch (error) {
//       console.error("Error saving category:", error);
//       toast.error(
//         "Error saving category: " + (error.message || "Unknown error")
//       );
//     }
//   };

//   const handleModalClose = () => {
//     setModalVisible(false);
//     form.resetFields();
//     setEditingCategory(null);
//     setImageUrl("");
//     setImageFile(null);
//   };

//   const handleAddNew = () => {
//     setEditingCategory(null);
//     setImageUrl("");
//     setImageFile(null);
//     form.resetFields();
//     setModalVisible(true);
//   };

//   // Handle pagination change
//   const handleTableChange = (pagination) => {
//     setCurrentPage(pagination.current);
//     setPageSize(pagination.pageSize);
//   };

//   return (
//     <div>
//       <div
//         style={{
//           marginBottom: 16,
//           display: "flex",
//           justifyContent: "space-between",
//         }}
//       >
//         <Title level={3}>Categories Management</Title>
//         <Button type="primary" icon={<PlusOutlined />} onClick={handleAddNew}>
//           Add Category
//         </Button>
//       </div>

//       <Table
//         columns={columns}
//         dataSource={categories}
//         loading={loading}
//         rowKey="_id"
//         pagination={{
//           current: currentPage,
//           pageSize: pageSize,
//           total: total,
//           showSizeChanger: true,
//           showTotal: (total, range) =>
//             `${range[0]}-${range[1]} of ${total} items`,
//           pageSizeOptions: ["5", "10", "20", "50", "100"],
//         }}
//         onChange={handleTableChange}
//       />

//       <Modal
//         title={editingCategory ? "Edit Category" : "Add Category"}
//         visible={modalVisible}
//         onCancel={handleModalClose}
//         footer={null}
//         width={600}
//       >
//         <Form form={form} layout="vertical" onFinish={handleSubmit}>
//           <Form.Item
//             name="name"
//             label="Category Name"
//             rules={[{ required: true, message: "Please enter category name" }]}
//           >
//             <Input placeholder="Enter category name" />
//           </Form.Item>

//           <Form.Item label="Category Image">
//             <Tabs
//               activeKey={selectedImageSource}
//               onChange={setSelectedImageSource}
//             >
//               <TabPane tab="Upload New" key="upload">
//                 <Upload
//                   name="avatar"
//                   listType="picture-card"
//                   className="avatar-uploader"
//                   showUploadList={false}
//                   customRequest={customUpload}
//                   beforeUpload={(file) => {
//                     const isImage = file.type.startsWith("image/");
//                     if (!isImage) {
//                       toast.error("You can only upload image files!");
//                       return false;
//                     }
//                     const isLt2M = file.size / 1024 / 1024 < 2;
//                     if (!isLt2M) {
//                       toast.error("Image must be smaller than 2MB!");
//                       return false;
//                     }
//                     return true;
//                   }}
//                   onChange={handleImageUpload}
//                 >
//                   {imageUrl ? (
//                     <img
//                       src={imageUrl}
//                       alt="Category"
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                       }}
//                     />
//                   ) : (
//                     <div>
//                       <PlusOutlined />
//                       <div style={{ marginTop: 8 }}>Upload</div>
//                     </div>
//                   )}
//                 </Upload>
//               </TabPane>
//             </Tabs>
//           </Form.Item>

//           <Form.Item name="description" label="Description">
//             <TextArea rows={4} placeholder="Enter category description" />
//           </Form.Item>

//           <Form.Item>
//             <Space>
//               <Button
//                 type="primary"
//                 htmlType="submit"
//                 loading={creating || editing}
//               >
//                 {editingCategory ? "Update" : "Add"}
//               </Button>
//               <Button onClick={handleModalClose}>Cancel</Button>
//             </Space>
//           </Form.Item>
//         </Form>
//       </Modal>
//     </div>
//   );
// };

// export default CategoriesSection;
import React, { useState, useEffect } from "react";
import {
  Layout,
  Menu,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
  Popconfirm,
  message,
  Row,
  Col,
  Statistic,
  Tag,
  Tabs,
  DatePicker,
  Upload,
  Switch,
  Divider,
  Badge,
  Typography,
  Drawer,
  TreeSelect,
} from "antd";
import {
  ShoppingCartOutlined,
  AppstoreOutlined,
  TagsOutlined,
  GiftOutlined,
  DashboardOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  UploadOutlined,
  DollarOutlined,
  ShoppingOutlined,
  UserOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import { categoryService, productService } from "../services";
import { useApiEnhanced } from "../hooks/useApiEnhanced";
import { toast } from "react-toastify";

const { Header, Sider, Content } = Layout;
const { Option } = Select;
const { TextArea } = Input;
const { Title, Text } = Typography;
const { TabPane } = Tabs;

const CategoriesSection = () => {
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);

  const {
    data: list,
    loading,
    error,
    execute: refetchProducts,
  } = useApiEnhanced(
    () => categoryService.getCategories({ page: currentPage, limit: pageSize }),
    true // Load immediately
  );

  const { loading: creating, execute: createCategory } = useApiEnhanced(
    (productData) => categoryService.createCategory(productData),
    { immediate: false }
  );

  const { loading: editing, execute: editCategory } = useApiEnhanced(
    (id, productData) => categoryService.updateCategory(id, productData),
    { immediate: false }
  );

  const { loading: deleting, execute: deleteCategory } = useApiEnhanced(
    (id) => categoryService.deleteCategory(id),
    { immediate: false }
  );

  const [imageUrl, setImageUrl] = useState("");
  const [imageGalleryVisible, setImageGalleryVisible] = useState(false);
  const [selectedImageSource, setSelectedImageSource] = useState("upload");
  const [imageFile, setImageFile] = useState(null);
  const [categories, setCategories] = useState([]);
  const [allCategories, setAllCategories] = useState([]); // For parent dropdown
  const [modalVisible, setModalVisible] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [form] = Form.useForm();

  // Update categories when data loads
  useEffect(() => {
    if (!loading && list?.data) {
      setCategories(list.data);
      setAllCategories(list.data); // Store all for parent selection
      setTotal(list.total || list.pagination?.total || 0);
    }
  }, [loading, list]);

  // Refetch when pagination changes
  useEffect(() => {
    refetchProducts();
  }, [currentPage, pageSize]);

  // Get category path (Parent > Child > Grandchild)
  const getCategoryPath = (categoryId, categories) => {
    const category = categories.find((cat) => cat._id === categoryId);
    if (!category) return "";

    const path = [category.name];
    let currentCat = category;

    // Traverse up the parent chain
    while (currentCat.parent) {
      const parentCat = categories.find(
        (cat) =>
          cat._id === currentCat.parent._id || cat._id === currentCat.parent
      );
      if (parentCat) {
        path.unshift(parentCat.name);
        currentCat = parentCat;
      } else {
        break;
      }
    }

    return path.join(" > ");
  };

  // Build tree data for TreeSelect with full path display
  const buildTreeData = (categories, editingId = null) => {
    // Filter out the category being edited to prevent circular reference
    const availableCategories = categories.filter(
      (cat) => cat._id !== editingId
    );

    // Get root categories (no parent)
    const rootCategories = availableCategories.filter((cat) => !cat.parent);

    const buildNode = (category, parentPath = "") => {
      const currentPath = parentPath
        ? `${parentPath} > ${category.name}`
        : category.name;

      const children = availableCategories.filter((cat) => {
        const parentId = cat.parent?._id || cat.parent;
        return parentId === category._id;
      });

      return {
        title: currentPath, // Show full path
        value: category._id,
        key: category._id,
        children:
          children.length > 0
            ? children.map((child) => buildNode(child, currentPath))
            : undefined,
      };
    };

    return rootCategories.map((cat) => buildNode(cat));
  };

  // Convert categories to flat list with paths (for create mode)
  const convertCategoryWithPaths = (categories, editingId = null) => {
    const availableCategories = categories.filter(
      (cat) => cat._id !== editingId
    );

    return availableCategories.map((category) => {
      const path = getCategoryPath(category._id, availableCategories);
      return {
        title: path, // Full path: Parent > Child > Grandchild
        value: category._id,
        key: category._id,
      };
    });
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (image) => (
        <img
          src={image?.url || "https://via.placeholder.com/50"}
          alt="Category"
          style={{ width: 50, height: 50, objectFit: "cover", borderRadius: 8 }}
        />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <Space>
          {text}
          {!record.parent && <Tag color="blue">Root</Tag>}
        </Space>
      ),
    },
    {
      title: "Parent Category",
      dataIndex: "parent",
      key: "parent",
      render: (parent) => {
        if (!parent) return <Tag color="default">None</Tag>;
        const parentName =
          parent?.name || categories.find((c) => c._id === parent)?.name;
        return parentName ? <Tag color="green">{parentName}</Tag> : "-";
      },
    },
    { title: "Description", dataIndex: "description", key: "description" },
    {
      title: "Product Count",
      dataIndex: "productCount",
      key: "productCount",
      render: (count) => <Badge count={count} showZero color="#faad14" />,
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (isActive) => (
        <Tag color={isActive ? "success" : "default"}>
          {isActive ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
            size="small"
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this category?"
            onConfirm={() => handleDelete(record._id)}
          >
            <Button icon={<DeleteOutlined />} danger size="small">
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleEdit = (category) => {
    setEditingCategory(category);
    setImageUrl(category.image?.url || "");
    setImageFile(null);

    form.setFieldsValue({
      name: category.name,
      description: category.description,
      parent: category.parent?._id || category.parent || undefined,
      isActive: category.isActive !== undefined ? category.isActive : true,
      order: category.order || 0,
    });
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      let res = await deleteCategory(id);
      console.log(res, "res success delete");
      if (!res?.success) return toast.error(res?.message);

      // Refresh data after delete
      await refetchProducts();
      toast.success("Category deleted successfully");
    } catch (error) {
      console.log(error, "error throw");
      return toast.error(
        error?.response?.data?.message || "something went wrong!"
      );
    }
  };

  const handleImageUpload = (info) => {
    const file = info.file.originFileObj || info.file;
    setImageFile(file);

    const reader = new FileReader();
    reader.onload = (e) => {
      setImageUrl(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  const customUpload = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const handleSubmit = async (values) => {
    console.log("Form submission values:", values);
    console.log("Current imageFile:", imageFile);
    console.log("Current imageUrl:", imageUrl);

    const formData = new FormData();
    formData.append("name", values.name);
    formData.append("description", values.description || "");
    formData.append(
      "isActive",
      values.isActive !== undefined ? values.isActive : true
    );
    formData.append("order", values.order || 0);

    // Handle parent category
    if (values.parent) {
      formData.append("parent", values.parent);
    }

    if (editingCategory) {
      if (imageFile) {
        formData.append("image", imageFile);
        console.log("New image file added for edit:", imageFile.name);
      } else {
        console.log("No new image selected, keeping existing image");
      }
    } else {
      if (imageFile) {
        formData.append("image", imageFile);
        console.log("Image file added for create:", imageFile.name);
      }
    }

    console.log("FormData contents:");
    for (let pair of formData.entries()) {
      console.log(pair[0] + ": ", pair[1]);
    }

    try {
      if (editingCategory) {
        let res = await editCategory(editingCategory._id, formData);
        console.log(res, "edit response");
        if (!res?.success)
          return toast.error(res?.message || "Category not able to edit");
        toast.success("Category updated successfully");
      } else {
        let result = await createCategory(formData);
        console.log(result, "result category");
        if (!result?.success)
          return toast.error(result?.message || "Failed to create category");
        toast.success("Category added successfully");
      }

      // Refresh data from server
      await refetchProducts();
      handleModalClose();
    } catch (error) {
      console.error("Error saving category:", error);
      toast.error(
        "Error saving category: " + (error.message || "Unknown error")
      );
    }
  };

  const handleModalClose = () => {
    setModalVisible(false);
    form.resetFields();
    setEditingCategory(null);
    setImageUrl("");
    setImageFile(null);
  };

  const handleAddNew = () => {
    setEditingCategory(null);
    setImageUrl("");
    setImageFile(null);
    form.resetFields();
    setModalVisible(true);
  };

  // Handle pagination change
  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  return (
    <div>
      <div
        style={{
          marginBottom: 16,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Title level={3}>Categories Management</Title>
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAddNew}>
          Add Category
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={categories}
        loading={loading}
        rowKey="_id"
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: total,
          showSizeChanger: true,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
          pageSizeOptions: ["5", "10", "20", "50", "100"],
        }}
        onChange={handleTableChange}
      />

      <Modal
        title={editingCategory ? "Edit Category" : "Add Category"}
        visible={modalVisible}
        onCancel={handleModalClose}
        footer={null}
        width={700}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Category Name"
                rules={[
                  { required: true, message: "Please enter category name" },
                ]}
              >
                <Input placeholder="Enter category name" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="parent"
                label="Parent Category"
                tooltip="Leave empty to create a root category"
              >
                <TreeSelect
                  showSearch
                  placeholder="Select parent category (optional)"
                  allowClear
                  treeDefaultExpandAll
                  treeData={buildTreeData(allCategories, editingCategory?._id)}
                  filterTreeNode={(input, treeNode) =>
                    treeNode.title.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item label="Category Image (Optional)">
            <Tabs
              activeKey={selectedImageSource}
              onChange={setSelectedImageSource}
            >
              <TabPane tab="Upload New" key="upload">
                <Upload
                  name="avatar"
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                  customRequest={customUpload}
                  beforeUpload={(file) => {
                    const isImage = file.type.startsWith("image/");
                    if (!isImage) {
                      toast.error("You can only upload image files!");
                      return false;
                    }
                    const isLt2M = file.size / 1024 / 1024 < 2;
                    if (!isLt2M) {
                      toast.error("Image must be smaller than 2MB!");
                      return false;
                    }
                    return true;
                  }}
                  onChange={handleImageUpload}
                >
                  {imageUrl ? (
                    <img
                      src={imageUrl}
                      alt="Category"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <div>
                      <PlusOutlined />
                      <div style={{ marginTop: 8 }}>Upload</div>
                    </div>
                  )}
                </Upload>
              </TabPane>
            </Tabs>
          </Form.Item>

          <Form.Item name="description" label="Description">
            <TextArea rows={4} placeholder="Enter category description" />
          </Form.Item>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="order"
                label="Display Order"
                tooltip="Lower numbers appear first"
                initialValue={0}
              >
                <InputNumber
                  min={0}
                  style={{ width: "100%" }}
                  placeholder="0"
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="isActive"
                label="Status"
                valuePropName="checked"
                initialValue={true}
              >
                <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Space>
              <Button
                type="primary"
                htmlType="submit"
                loading={creating || editing}
              >
                {editingCategory ? "Update Category" : "Add Category"}
              </Button>
              <Button onClick={handleModalClose}>Cancel</Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default CategoriesSection;
// ```

// **Key Changes:**

// 1. ✅ **`getCategoryPath` function** - Recursively builds the full path "Parent > Child > Grandchild"
// 2. ✅ **`buildTreeData` updated** - Shows full hierarchy path in tree structure
// 3. ✅ **Removed `convertCategory`** - Not needed anymore, using `buildTreeData` for both create and edit
// 4. ✅ **Fixed parent field handling** - Properly handles `parent._id` or `parent`
// 5. ✅ **Better parent column display** - Shows parent name correctly in table

// **Now the TreeSelect will show:**
// ```
// Clothing
// Clothing > Men
// Clothing > Men > Shirts
// Clothing > Men > Pants
// Clothing > Women
// Clothing > Women > Dresses
// Electronics
// Electronics > Phones
// Electronics > Laptops
